import { Position } from '@root/private/js/common/watermark/watermark.interface';

export const checkOverlap = (pos: Position, newPos: Position) => {
  function isOverlapping(a: Position, b: Position): boolean {
    return !(
      a.left + a.width < b.left ||
      a.left > b.left + b.width ||
      a.top + a.height < b.top ||
      a.top > b.top + b.height
    );
  }

  // 거리 체크 (중심 간 거리)
  function isTooClose(a: Position, b: Position, minDistance = 100): boolean {
    const ax = a.left + a.width / 2;
    const ay = a.top + a.height / 2;
    const bx = b.left + b.width / 2;
    const by = b.top + b.height / 2;

    const dx = ax - bx;
    const dy = ay - by;

    return Math.sqrt(dx * dx + dy * dy) < minDistance;
  }

  return isOverlapping(pos, newPos) || isTooClose(pos, newPos, 100);
};
